<template>
  <main>
    <LimitTimeModal
      :timeLimit="currentMaterial?.expectedConclusionTime * 1000"
      :nameStudent="user?.firstName"
      @onOpenChat="openChatHomero"
      @onNeedsToPause="onNeedsToPause"
    />
    <main
      v-motion
      id="chat"
      :initial="initialMotion"
      :enter="enterMotion"
      v-if="openChat"
      :class="`chat-bot w-[85vw] h-[100vh] ${hSize} z-50 lg:z-0 lg:static fixed bottom-0 rounded-t-sm transition-all bg-blue-400`"
    >
      <section
        v-if="recorded"
        id="chat-record"
        class="recorder-body absolute w-full z-20 flex justify-center items-center rounded-t-sm h-[90%] sm:h-[88%]"
      >
        <Recording @onRecordStop="recordStop()" />
      </section>

      <section
        id="chat-header"
        class="p-4 w-full bg-white border-b rounded-t-sm relative flex flex-row items-center space-x-4"
      >
        <button class="absolute top-4 right-4" @click="closeChat()">
          <v-icon name="md-close" class="text-primary-400" />
        </button>

        <img src="@/assets/images/avatares/avatar.svg" alt="avatar" />
        <div>
          <h4>Homero</h4>
          <p class="text-gray-400">Online</p>
        </div>
      </section>

      <section
        id="chat-messages"
        class="chat-body bg-white p-8 overflow-auto transition-all"
      >
        <Messages
          @onOpenCrawler="openCrawler"
          :messages="messages"
          :action="{ isGpt }"
          :loaderMsg="loaderMsg"
          :autoPlay="autoPlay"
        />
      </section>

      <section
        id="chat-footer"
        class="w-full bg-white flex flex-row space-x-3 p-5 absolute bottom-0 break-words"
      >
        <Footer
          @onRecordStop="recordStop()"
          @onStartRecord="startStreaming()"
          @onGetMessage="getMessageDiv()"
          :textSize="verifyTextSize()"
          :recorded="recorded"
        />
      </section>
    </main>

    <div class="fixed bottom-1 right-1 z-10 flex items-end flex-col">
      <SpeechBubble
        @onCloseSpeechBubble="closeSpeechBubble"
        @onOpenChat="openChatHomero"
        @onHomeroRandomQuestion="homeroRandomQuestion"
        v-if="startMessage"
        :startMessage="startMessage"
        :user="user"
        :msgType="speechBubbleType"
      />
      <button
        v-if="!openChat"
        @click="openChatHomero()"
        @mouseenter="speechBubbleType === 'default' ? openSpeechBubble() : ''"
        @mouseout="speechBubbleType === 'default' ? closeSpeechBubble() : ''"
        :class="`bg-cover w-[80px] h-[80px] xl:w-[100px] xl:h-[100px] bg-[url('@/assets/images/avatares/avatar-chatbot.svg')] hover:scale-95 transition-all ${
          hasSpeech === true ? 'animate-ping' : ''
        }`"
      ></button>
    </div>

    <ModalPermissionBrowser
      v-if="showModalPermissionBrowser"
      :showModalPermissionBrowser="showModalPermissionBrowser"
      @onCloseModalPermissionBrowser="closeModalPermissionBrowser"
    />

    <Crawler v-if="showModal" @onClose="onCloseCrawler" :keyword="keyword" />
  </main>
</template>

<script lang="ts">
import { SpeechActions } from "@/components/SpeechRecognition/actions";
import { ChatModel } from "@/models/chat.model";
import { Material } from "@/models/material.model";
import {
  MotionEnter,
  MotionInitial,
  MotionTransition,
} from "@/models/motion.model";
import { RandomQuestion } from "@/models/quiz.model";
import { useChatStore } from "@/store/linear/chat";
import { useVideoStore } from "@/store/video";
import { GoToRoute } from "@/utils/go-to.util";
import { MediaPermissionsError } from "mic-check";
import { defineAsyncComponent, defineComponent, PropType } from "vue";
import {
  ChatbotAction,
  checkMessage,
  QuestionType,
  SpeechBubbleMsg,
} from "../chatbot.utils";
import { ChatBotService } from "./../chat-bot.service";
import { useMaterialStore } from "@/store/linear/material";

const SpeechBubble = defineAsyncComponent(
  () => import("../SpeechBubble/speech-bubble.vue")
);
const Crawler = defineAsyncComponent(
  () => import("@/views/Crawler/crawler.vue")
);
const Footer = defineAsyncComponent(() => import("./Footer/footer.vue"));
const Messages = defineAsyncComponent(() => import("./Messages/messages.vue"));
const Recording = defineAsyncComponent(
  () => import("./Recording/recording.vue")
);

export default defineComponent({
  name: "chat",
  emits: ["onBackMaterial", "onNeedsToPause", "onCheckVideoEnded", "onOpen"],
  components: {
    SpeechBubble,
    Crawler,
    Footer,
    Messages,
    Recording,
  },
  data() {
    return {
      writeMsg: "" as string,
      stream: {} as any,
      messages: [] as ChatModel[],
      message: {
        audio: "",
        message: "",
        options: [],
        type: "text",
        user: "homero",
        show: true,
      } as ChatModel,
      rec: {} as MediaRecorder,
      recorded: false as boolean,
      audioON: false as boolean,
      autoPlay: false as boolean,
      textSize: 6,
      data: [] as any,
      loaderMsg: false as boolean,
      openChat: false as boolean,
      hasSpeech: false as boolean,
      startMessage: false as boolean,
      TIMER: 5000 as number,
      speechBubbleType: "default" as string,
      showModalPermissionBrowser: false as boolean,
      actionMessage: "" as string,
      currentPrompt: "" as any,
      isGpt: false as boolean,
      showModal: false as boolean,
      keyword: "" as string,
      initialMotion: new MotionInitial(0, 0, 100),
      enterMotion: new MotionEnter(1, 0, 0, new MotionTransition(250)),
    };
  },
  watch: {
    messages: {
      handler(val, oldVal) {
        setTimeout(() => {
          this.scrollToEnd();
        }, 200);
      },
      deep: true,
    },
  },
  updated() {
    this.scrollToEnd();
  },
  props: {
    indexMaterial: {
      required: true,
      type: Number,
    },
    user: Object,
    msgType: {
      type: String,
      default: "default",
    },
    startMsg: {
      type: Boolean,
      default: false,
    },
    randomQuestion: {
      type: Object as PropType<RandomQuestion>,
    },
    currentMaterial: {
      type: Object as PropType<Material>,
    },
    hSize: {
      type: String,
    },
  },
  created() {
    this.chatbot.wsMessages().subscribe((e) => {
      this.isGpt = false;
      const parse = JSON.parse(e);
      if (parse?.hasAction) {
        this.actions(parse?.action?.type);
      } else {
        this.pushMessage(checkMessage(parse));
      }
      this.loaderMsg = false;
    });
  },
  mounted() {
    this.scrollToEnd();
    this.messageStore();
    this.openWithSpeech();
    this.startMessage = this.startMsg;
    this.speechBubbleType = this.msgType;
  },
  unmounted() {
    sessionStorage.removeItem("messages");
  },
  computed: {
    chatbot(): ChatBotService {
      return new ChatBotService();
    },
    idCourse(): any {
      return this.$route.params.id;
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  methods: {
    onBackMaterial(value: number): void {
      this.$emit("onBackMaterial", value);
    },
    onCheckVideoEnded(): void {
      this.$emit("onCheckVideoEnded");
    },
    onNeedsToPause(value: boolean): void {
      this.$emit("onNeedsToPause", value);
      useVideoStore.getPlayer?.pause();
    },
    closeModalPermissionBrowser(): void {
      this.showModalPermissionBrowser = false;
    },
    scrollToEnd(): void {
      if (this.openChat) {
        var container: any = document.querySelector(".chat-body");
        var scrollHeight = container?.scrollHeight;
        setTimeout(() => {
          container.scrollTop = scrollHeight;
        }, 150);
      }
    },
    messageStore(): void {
      let messageStorage = sessionStorage.getItem("messages");
      if (messageStorage) {
        this.messages = JSON.parse(messageStorage);
        this.autoPlay = false;
      } else {
        this.message.message = this.chatbot.getStartMessage(
          this.user?.firstName
        );
        this.message.options = [];
        this.pushMessage(this.message);
      }
    },
    saveMessageLocal(text: string, type: string, audio: any = ""): void {
      this.message.audio = audio;
      this.message.message = text;
      this.message.type = type;
      this.message.user = "me";
      this.pushMessage(this.message);
      this.writeMsg = "";
      this.loaderMsg = true;
      if (type == "text" && text && this.actionMessage === "") {
        this.chatbot.sendTextMessage(text);
      } else if (type == "text" && text && this.actionMessage) {
        this.chatbot.sendTextMessage(text, QuestionType[this.actionMessage]);
        this.actionMessage = "";
      }
    },
    async startStreaming(): Promise<void> {
      await navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((e) => {
          this.stream = e;
          if (this.stream) {
          }
          this.recordStart();
        })
        .catch((error: MediaPermissionsError) => {
          this.showModalPermissionBrowser = true;
        });
    },
    stopStreaming(): void {
      if (this.stream) {
        this.stream.getAudioTracks()[0].stop();
      }
    },
    recordStart(): void {
      const rec = new MediaRecorder(this.stream);
      this.rec = rec;
      this.data.length = 0;
      rec.start();
      this.recorded = true;
    },
    recordStop(): void {
      this.rec.stop();
      this.recorded = false;
      this.rec.ondataavailable = (e) => {
        this.data.push(e.data);
      };
      this.rec.onstop = () => {
        const blob = new Blob(this.data, { type: this.rec.mimeType });
        var blobUrl = URL.createObjectURL(blob);
        this.saveMessageLocal("audio", "audio", blobUrl);
        if (this.actionMessage) {
          this.chatbot.answerOpenQuestion(
            blob,
            this.currentPrompt,
            this.actionMessage
          );
          this.actionMessage = "";
        } else {
          blob.arrayBuffer().then((buffer) => {
            let a1 = new Uint8Array([0x0]);
            let a2 = new Uint8Array(buffer);
            let concat = new Uint8Array([...a1, ...a2]);
            this.chatbot.sendBlobMessage(new Blob([concat.buffer]));
            this.loaderMsg = true;
          });
        }
      };
      this.stopStreaming();
    },
    pushMessage(msg: ChatModel): void {
      let message: any = {
        message: msg.message,
        type: msg.type,
        user: msg.user,
        options: msg.options,
        audio: msg.audio,
      };
      message.message ? this.messages.push(message) : "";
      this.autoPlay = message.message ? true : false;
      sessionStorage.setItem("messages", JSON.stringify(this.messages));
    },
    closeChat(): void {
      this.openChat = false;
      this.hasSpeech = false;
      this.$emit("onOpen", this.openChat);
      useChatStore.setOpen(false);
      if (useMaterialStore.isVideo) useVideoStore.getPlayer?.play();
    },
    openChatHomero(): void {
      if (useMaterialStore.isVideo) this.onNeedsToPause(true);
      useChatStore.setOpen(true);
      this.openChat = true;
      this.$emit("onOpen", this.openChat);
      useVideoStore.getPlayer?.pause();
    },
    getMessageDiv(): void {
      const element: any = document.getElementById("message");
      let message1: string = element?.innerHTML.toString();
      let message2 = message1.replace("<div>", "<br> ");
      let messageFinal = message2.replace("</div>", " ");
      this.saveMessageLocal(messageFinal, "text");
      element.textContent = "";
    },
    verifyTextSize(): boolean {
      const element: any = document.getElementById("message")
        ? document.getElementById("message")
        : null;
      if (element && element.textContent.length > this.textSize) {
        return false;
      }
      return true;
    },
    actions(action: string): void {
      this.isGpt = false;
      if (action === ChatbotAction.COME_BACK_OBJECT) {
        if (this.indexMaterial == 0) {
          let msg = new ChatModel();
          msg.message = this.$t("chat.nextObjectWarning");
          msg.user = "homero";
          this.messages.pop();
          this.pushMessage(msg);
        } else {
          this.onBackMaterial(-1);
        }
      } else if (action === ChatbotAction.NEXT_OBJECT) {
        this.onCheckVideoEnded();
      } else if (action === ChatbotAction.IS_GPT) {
        this.isGpt = true;
      }
    },
    openWithSpeech(): void {
      SpeechActions.chat.subscribe({
        next: (response) => {
          if (this.openChat === false && response === true) {
            this.hasSpeech = true;
            this.autoPlay = false;
            setTimeout(() => {
              this.openChatHomero();
              this.sendActionWithRecord();
              this.hasSpeech = false;
              SpeechActions.chatOpen(false);
            }, 1500);
          }
        },
      });
    },
    sendActionWithRecord(): void {
      this.startStreaming();
      setTimeout(() => {
        this.recordStop();
      }, this.TIMER);
    },
    openSpeechBubble(typeSpeechBubble: string = "default"): void {
      this.isGpt = false;
      if (this.openChat === false) {
        this.startMessage = true;
        this.speechBubbleType = typeSpeechBubble;
      } else {
        const question = new ChatModel();
        question.message = this.chatbot.getSpeechBubbleMessage(
          typeSpeechBubble,
          this.user?.firstName,
          this.$t("labels.generic", {
            pt: SpeechBubbleMsg[typeSpeechBubble].pt,
            en: SpeechBubbleMsg[typeSpeechBubble].en,
          })
        );
        question.user = "homero";
        if (!typeSpeechBubble.includes("tutorial")) {
          question.options.push({
            name: this.$t("chat.testLearned"),
            active: true,
            action: () => {
              if (question.options[0].active) {
                let userQuestion = new ChatModel();
                userQuestion.message = this.$t("chat.testLearned");
                userQuestion.user = "me";
                this.pushMessage(userQuestion);
                this.homeroRandomQuestion(typeSpeechBubble);
              }
              question.options[0].active = false;
            },
          });
        }
        this.pushMessage(question);
      }
    },
    closeSpeechBubble(): void {
      this.startMessage = false;
      this.speechBubbleType = "default";
    },
    homeroRandomQuestion(questionType: string): void {
      this.actionMessage = questionType;
      this.currentPrompt =
        QuestionType[questionType] === QuestionType.QUESTION_RANDOM
          ? this.randomQuestion?.randomQuestion?.prompt
          : this.randomQuestion?.wrongQuestion?.prompt;
      this.message.message = `<div>
        <p>${this.$t("chat.reviewLearned")} </p>
        <p class='font-bold'>${this.currentPrompt}</p>
      </div>`;
      this.message.user = "homero";

      this.pushMessage(this.message);
    },
    openCrawler(keyword: string): void {
      this.showModal = true;
      this.onNeedsToPause(true);
      this.keyword = keyword;
    },
    onCloseCrawler(value: boolean = false): void {
      this.showModal = value;
      this.keyword = "";
    },
  },
});
</script>

<style lang="scss" src="./style.scss"></style>
